import { AudioViewer } from 'Components/common/AudioViewer/AudioViewer'
import { VideoPlayer } from 'shared/components/VideoPlayer/VideoPlayer'
import { getFileDownloadUrl } from 'Services/tasks.service'
import './File.less'

type FilePreviewProps = {
    url: string
    name: string
    onClose: () => void
    type: 'image' | 'audio' | 'video' | 'file'
}

import { useState, useEffect, useMemo } from 'react'
import { CloseOutlined } from '@ant-design/icons'

export const FilePreview = (props: FilePreviewProps) => {
    const [url, setUrl] = useState<string>('')

    useEffect(() => {
        let isMounted = true
        getFileDownloadUrl(props.url).then(downloadUrl => {
            if (isMounted) setUrl(downloadUrl)
        })
        return () => {
            isMounted = false
        }
    }, [props.url])

    const filePreviewContent = useMemo(() => {
        if (props.type === 'image') {
            return <img src={url} alt={props.name} className="preview-image" />
        } else if (props.type === 'audio') {
            return <AudioViewer url={url} />
        } else if (props.type === 'video') {
            return (
                <div className="video-player-container">
                    <VideoPlayer url={url} id={props.name} />
                </div>
            )
        }
        return null
    }, [props.name, props.type, url])

    if (!url) {
        return <></>
    }

    return (
        <div className="file-preview-container">
            {filePreviewContent}
            <CloseOutlined className="close-button" onClick={props.onClose} />
        </div>
    )
}
